/** @license See the LICENSE file. */
// This code is auto-generated, do not modify this file!
const version = '1.0.3';
export {version};
